"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpecialtiesSelector = exports.useMedicationsAvailableSelector = exports.useAttributeListSelector = exports.useAttributeInflatorSelector = exports.default = void 0;

var _attributeIds = _interopRequireDefault(require("@devsontap/nica-api/core/utils/attributeIds"));

var _index = require("../index");

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var INITIAL_STATE = {
  loading: true,
  attributeIds: null,
  attributeMap: {},
  error: null
};

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _types.ATTRIBUTES_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        error: null
      });

    case _types.ATTRIBUTES_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        attributeIds: action.payload.map(function (attribute) {
          return attribute.key;
        }),
        attributeMap: action.payload.reduce(function (map, attribute) {
          map[attribute.key] = attribute;
          return map;
        }, _objectSpread({}, state.attributeMap))
      });

    case _types.ATTRIBUTES_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.error
      });

    default:
      return state;
  }
};

exports.default = _default;

var useAttributeInflatorSelector = function useAttributeInflatorSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref) {
    var attributes = _ref.attributes;
    return attributes.attributeIds && attributes.attributeIds.map(function (id) {
      return attributes.attributeMap[id];
    }) || [];
  });
};
/**
 * Returns the data necessary to render the attribute list
 */


exports.useAttributeInflatorSelector = useAttributeInflatorSelector;

var useAttributeListSelector = function useAttributeListSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref2) {
    var attributes = _ref2.attributes;
    var attributeList = attributes.attributeIds ? attributes.attributeIds.map(function (id) {
      return attributes.attributeMap[id];
    }) : null;
    return {
      loading: attributes.loading,
      attributeIds: attributes.attributeIds,
      error: attributes.error,
      attributeList: attributeList
    };
  });
};

exports.useAttributeListSelector = useAttributeListSelector;

var useMedicationsAvailableSelector = function useMedicationsAvailableSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref3) {
    var attributeMap = _ref3.attributes.attributeMap;

    if (attributeMap[_attributeIds.default.medicationsAvailable]) {
      var groups = attributeMap[_attributeIds.default.medicationsAvailable].groups;
      return Object.keys(groups).map(function (groupId) {
        var options = groups[groupId].options;
        return Object.keys(options).map(function (optionId) {
          return {
            id: optionId,
            name: options[optionId].name
          };
        });
      }).reduce(function (result, groupOptions) {
        return [].concat(_toConsumableArray(result), _toConsumableArray(groupOptions));
      }, []).sort(function (item1, item2) {
        return item1.name.localeCompare(item2.name);
      });
    }

    return null;
  });
};

exports.useMedicationsAvailableSelector = useMedicationsAvailableSelector;

var useSpecialtiesSelector = function useSpecialtiesSelector() {
  return (0, _index.useShallowEqualSelector)(function (_ref4) {
    var attributeMap = _ref4.attributes.attributeMap;

    if (attributeMap[_attributeIds.default.practiceSpecialty]) {
      var options = attributeMap[_attributeIds.default.practiceSpecialty].options;
      return Object.keys(options).map(function (optionId) {
        return {
          id: optionId,
          name: options[optionId].name
        };
      }).sort(function (item1, item2) {
        return item1.name.localeCompare(item2.name);
      });
    }

    return null;
  });
};

exports.useSpecialtiesSelector = useSpecialtiesSelector;